module.exports = __webpack_public_path__ + "static/skullAR-a3c90350b15a30118610878cae0695d5.webm";